module.exports = __webpack_public_path__ + "img/gnzs8.80aea865.png";